import(/* webpackMode: "eager" */ "/home/runner/work/mintun/mintun/web/app/collection/create/page.tsx")